import { render, staticRenderFns } from "./AddBulk.vue?vue&type=template&id=7add16d1&scoped=true&lang=pug&"
import script from "./AddBulk.vue?vue&type=script&lang=js&"
export * from "./AddBulk.vue?vue&type=script&lang=js&"
import style0 from "./AddBulk.vue?vue&type=style&index=0&id=7add16d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add16d1",
  null
  
)

export default component.exports